import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

const AdminCoursesPopup = (props) => {
  return (
    <Dialog open={props.isPopupOpen} onClose={props.handleClosePopup}>
      <DialogTitle>
        <div className="center">{props.popupTitle}</div>
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        <div className="flex justify-between width100 mt-30">
          <div className="ml-10">
            <Button color="primary" variant="contained" onClick={props.handleAction}>
              {props.buttonText}
            </Button>
          </div>
          <div>
            <Button color="secondary" variant="contained" onClick={props.handleClosePopup}>
              לבטל
            </Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AdminCoursesPopup;
